import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
// let baseUrl = `${httpUrl.host}`

let api = {
  // 最新政策分页
  getNewestPolicyPage: `${baseUrl}/hqptNewestPolicy/getPage`,

  // 最新政策详情
  getNewestPolicyDetail: `${baseUrl}/hqptNewestPolicy/getByCode`,

  // 热点问题分页
  getHotIssuePage: `${baseUrl}/hqptHotIssue/getPage`,

  // 热点问题详情
  getHotIssueDetail: `${baseUrl}/hqptHotIssue/getByCode`,

  // 直播分页
  getLivePage: `${baseUrl}/hqptLive/getPage`,

  // 直播详情
  getLiveDetail: `${baseUrl}/hqptLive/getByCode`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/EnterpriseFavour.js